import React, { useEffect, useState } from "react";
import { X, ArrowRight, Lock } from "lucide-react";
import { usePrice } from "@/lib/price";

const STORAGE_KEY = "jh_exit_shown_v1";

export default function ExitIntent() {
  const [open, setOpen] = useState(false);
  const { price } = usePrice();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    let shown = false;
    const trigger = () => {
      if (shown) return;
      shown = true;
      sessionStorage.setItem(STORAGE_KEY, "1");
      setOpen(true);
    };
    const onLeave = (e) => {
      if (e.clientY <= 0) trigger();
    };
    const idleTimer = setTimeout(trigger, 35000);

    document.addEventListener("mouseleave", onLeave);
    return () => {
      document.removeEventListener("mouseleave", onLeave);
      clearTimeout(idleTimer);
    };
  }, []);

  if (!open) return null;
  return (
    <div
      data-testid="exit-intent"
      className="fixed inset-0 z-[100] flex items-center justify-center p-5 bg-black/70"
      onClick={() => setOpen(false)}
    >
      <div
        className="relative w-full max-w-md bg-[#FDFBF7] border-4 border-[#0a0a0a] shadow-brutal-lg p-7 md:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="exit-intent-close"
          aria-label="Close"
          onClick={() => setOpen(false)}
          className="absolute -top-4 -right-4 w-10 h-10 bg-[#FFE600] border-4 border-[#0a0a0a] shadow-brutal-sm flex items-center justify-center hover:bg-[#FF3B30] hover:text-white"
        >
          <X size={18} strokeWidth={3} />
        </button>
        <div className="font-accent text-xs bg-[#FF3B30] text-white inline-block px-2.5 py-1 mb-3">
          WAIT —
        </div>
        <h3 className="font-display text-3xl md:text-4xl leading-tight">
          Leaving to grab your card?
        </h3>
        <p className="font-mono-body mt-4 text-[14px] leading-relaxed">
          You don&apos;t need one. Start free — no card required. Use the
          playbooks, job directory and toolbox forever. Upgrade only when
          you&apos;re ready.
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <a
            href="/login"
            data-testid="exit-intent-free"
            className="hover-pop inline-flex items-center justify-center gap-2 bg-[#FFE600] text-[#0a0a0a] border-4 border-[#0a0a0a] px-5 py-3.5 font-accent text-base shadow-brutal-sm"
            onClick={() => setOpen(false)}
          >
            Start free — no card
            <ArrowRight size={15} strokeWidth={3} />
          </a>
          <a
            href="https://whop.com/checkout/plan_hfsvR7lsOjQds"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="exit-intent-lock"
            className="inline-flex items-center justify-center gap-2 bg-[#0055FF] text-white border-4 border-[#0a0a0a] px-5 py-3.5 font-accent text-base hover:bg-[#0a0a0a]"
            onClick={() => setOpen(false)}
          >
            <Lock size={14} strokeWidth={3} /> Lock {price} instead
            <ArrowRight size={15} strokeWidth={3} />
          </a>
        </div>
        <div className="mt-5 font-mono-body text-[11px] text-[#0a0a0a]/60 text-center">
          One-time payment · lifetime access · 7-day refund
        </div>
      </div>
    </div>
  );
}
